import React from 'react';

import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import NoDataContainer from '@/views/component/NoDataContainer';
import { tableEmptyState } from '@/assets/images/index';
import {
	PAGE_NOT_FOUND_MESSAGE,
	PAGE_NOT_FOUND_TITLE,
} from '@/constants/utilsConstant';

const SplashContainer = styled.div`
	background-color: #ffffff;
	height: 80vh;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Splash = () => {
	const navigate = useNavigate();

	const navigateToDashboard = () => navigate('/dashboard', { replace: true });

	return (
		<SplashContainer>
			<NoDataContainer
				source={tableEmptyState}
				alt=""
				message={PAGE_NOT_FOUND_MESSAGE}
				title={PAGE_NOT_FOUND_TITLE}
				retry={navigateToDashboard}
				buttonText="Go To Dashboard"
			/>
		</SplashContainer>
	);
};

export default Splash;
